import styled from 'styled-components';

export const StyledGroupCard = styled.div`
    ${({ theme }) => `
    background: linear-gradient(263.61deg, #FFFFFF 15.63%, rgba(255, 255, 255, 0.5) 94.52%);
    border: 1px solid ${theme.palette.common.dimBlue};
    border-radius: 12px;
    box-sizing: border-box;

    min-width: 385px;
    width: 100%;
    height: 116px;
    padding: 15px;

    display: flex;
    flex-direction: column;
    row-gap: 5px;
`}
`;

export const StyledGroupHeader = styled.div`
    ${() => `
display: flex;
align-items: center;
column-gap: 20px;
justify-content: flex-start;
`}
`;
